import { useEffect } from 'react';
import { BUSINESS, SITE_URL } from '../data/site';
const SCHEMA_ID = 'reach-performance-localbusiness';
const SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'HealthClub',
  '@id': `${SITE_URL}/#organization`,
  name: BUSINESS.name,
  legalName: BUSINESS.legalName,
  url: SITE_URL,
  telephone: BUSINESS.phoneDisplay,
  email: BUSINESS.email,
  description: 'Sports performance training for high school and homeschool athletes in McKinney, Texas. Small-group strength and speed coaching with testing every 4 weeks.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: BUSINESS.street,
    addressLocality: BUSINESS.city,
    addressRegion: BUSINESS.state,
    postalCode: BUSINESS.zip,
    addressCountry: 'US'
  },
  location: {
    '@type': 'Place',
    name: BUSINESS.venue
  },
  areaServed: BUSINESS.areaServed.map(city => ({
    '@type': 'City',
    name: `${city}, TX`
  })),
  sameAs: [BUSINESS.instagram]
};
export function StructuredData() {
  useEffect(() => {
    let script = document.head.querySelector<HTMLScriptElement>(`#${SCHEMA_ID}`);
    if (!script) {
      script = document.createElement('script');
      script.id = SCHEMA_ID;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(SCHEMA);
  }, []);
  return null;
}